import { useState } from "react";
import Navbar from "@/components/core/Navbar";
import { Footer } from "@/components/core/Footer";
import { Login } from "./Login";
import { Register } from "./Register";
import { Button } from "antd";
import { AllUsers } from "./AllUsers";
import { getSmartStorageItem } from "@/utils/smartStorage";

export const Auth = () => {
    const [showLogin, setShowLogin] = useState(true); // true = login, false = register
    const role = getSmartStorageItem("role");

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                backgroundColor: "var(--color-bg)",
                minHeight: "100vh",
            }}
        >

            <div style={{ width: 300, margin: "20px 0" }}>
                {showLogin ? <Login /> : <Register />}

                <div style={{ textAlign: "center", marginTop: 10 }}>
                    {showLogin ? (
                        <>
                            Hesabın yok mu?{" "}
                            <Button type="link" onClick={() => setShowLogin(false)}>
                                Kayıt Ol
                            </Button>
                        </>
                    ) : (
                        <>
                            Zaten hesabın var mı?{" "}
                            <Button type="link" onClick={() => setShowLogin(true)}>
                                Giriş Yap
                            </Button>
                        </>
                    )}
                </div>
            </div>
            {role == "admin" &&
                (<AllUsers />)
            }
        </div>
    );
};